"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var format_price_1 = __importDefault(require("../../utils/format-price"));
var loading_modal_1 = __importDefault(require("../account-v3/components/loading_modal"));
var app_1 = require("./app");
var useContext = React.useContext;
var NavBar = function (_a) {
    var history = _a.history;
    var _b = useContext(app_1.AppContext), canGoNext = _b.canGoNext, totalNumChoices = _b.totalNumChoices, existingCustomerNewBundleParams = _b.existingCustomerNewBundleParams, existingBundle = _b.existingBundle, isSubmittingBundle = _b.isSubmittingBundle, pathBack = _b.pathBack, pathNext = _b.pathNext, submitBundle = _b.submitBundle, minSelectionTotal = _b.minSelectionTotal, totalBundlePrice = _b.totalBundlePrice, existingCustomerNewBundleSavings = _b.existingCustomerNewBundleSavings;
    var goBack = function () {
        if (pathBack) {
            history.push(pathBack);
        }
    };
    var goNext = function () {
        if (canGoNext && pathNext) {
            history.push(pathNext);
        }
    };
    var onClick = function () {
        if (!!existingBundle) {
            submitBundle();
        }
        else if (pathNext) {
            goNext();
        }
        else {
            submitBundle();
        }
    };
    var _c = __read((0, react_1.useMemo)(function () {
        var price = (0, format_price_1.default)(totalBundlePrice - (existingCustomerNewBundleSavings || 0));
        var matches = price.match(/^(.+?)\.(.+)$/);
        return matches ? matches.slice(1) : [null, null];
    }, [totalBundlePrice]), 2), dollars = _c[0], cents = _c[1];
    var centerContent = (React.createElement("div", null, dollars && cents ? (React.createElement("div", { className: 'position-relative', style: { top: 4 } },
        React.createElement("span", { className: 'font-bold lh1', style: { fontSize: 38 } }, dollars),
        React.createElement("sup", { style: { top: -17 } }, cents))) : null));
    return (React.createElement("div", { className: 'grid-x align-justify align-middle border-seashell bordered padding-4 bg-white', style: { borderWidth: '1px 0 0' } },
        React.createElement(loading_modal_1.default, { isLoading: isSubmittingBundle && !!existingCustomerNewBundleParams, error: false }),
        pathBack ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'cell shrink' },
                React.createElement("button", { className: 'width-100 text-black bg-white', onClick: goBack }, "\u2190 Back")),
            React.createElement("div", { className: 'cell auto text-center' }, centerContent))) : (React.createElement("div", { className: 'cell auto' },
            React.createElement("div", { className: 'margin-bottom-2' },
                React.createElement("span", { className: 'font-bold lh1', style: { fontSize: 20 } },
                    "(",
                    totalNumChoices,
                    ") selected")),
            React.createElement("div", { className: 'h7 text-nobel font-lighter lh1' },
                "Minimum ",
                minSelectionTotal,
                " products"))),
        React.createElement("div", { className: 'cell shrink', style: { maxWidth: '148px' } },
            React.createElement("button", { className: (0, classnames_1.default)('text-white', canGoNext ? 'bg-wisteria' : 'bg-pampas'), onClick: onClick, disabled: isSubmittingBundle || !canGoNext, style: { padding: '17px 19px' } }, (function () {
                if (isSubmittingBundle)
                    return 'Wait...';
                else if (!!existingBundle)
                    return 'Save';
                else if (pathNext)
                    return 'Next →';
                else if (existingCustomerNewBundleParams)
                    return 'Place Order';
                return 'Add To Cart';
            })()))));
};
exports.default = (0, react_router_dom_1.withRouter)(NavBar);
